import React, { useState, useRef } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import useOutsideClick from "../Hooks/useOutsideClick";
import PopupMenu from "../PopupMenu";

const HeaderProfileDetails = ({ initials, full_name, email, settings_path, logout_path }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef();
  const iconSize = "inherit";

  useOutsideClick(
    wrapperRef,
    (e) => !e.target?.closest?.(".header__profile__avatar") && setShowDropdown(false)
  );

  const header = (
    <div className="header__profile__dropdown__title">
      <div className="header__profile__avatar flex-shrink-0">
        <span className="header__profile__avatar__initials">{initials}</span>
      </div>
      <div className="ml-2">
        <div className="mb-1 t--md">{full_name}</div>
        <div className="header__profile__dropdown__email">{email}</div>
      </div>
    </div>
  );

  const options = [
    { name: "Settings", url: settings_path, icon: <SettingsOutlinedIcon fontSize={iconSize} /> },
    { name: "Log Out", url: logout_path, icon: <LogoutIcon fontSize={iconSize} /> },
  ];

  return (
    <div ref={wrapperRef} style={{ position: "relative" }}>
      <div className="header__profile__avatar" onClick={() => setShowDropdown(!showDropdown)}>
        <span className="header__profile__avatar__initials">{initials}</span>
      </div>
      <PopupMenu
        header={header}
        options={options}
        visible={showDropdown}
        top="calc(100% + 8px)"
        right="0"
        width="256px"
      />
    </div>
  );
};

export default HeaderProfileDetails;
